import { Component, inject, input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { EFormDataType } from 'scw-digital-boards-widgets';
import { IDropdownOption, MatDropdown } from '../../../../../shared/components/mat-dropdown/mat-dropdown.component';
import { IDropdownSettings } from '../../../../../shared/components/mat-dropdown/scw-mat-dropdown.interface';

@Component({
  imports: [MatDropdown],
  selector: 'form-data-type-dropdown',
  styleUrl: './form-data-type-dropdown.component.scss',
  templateUrl: './form-data-type-dropdown.component.html',
})
export class FormDataTypeDropdownComponent {
  private readonly translate = inject(TranslateService);

  public readonly formControl = input.required<FormControl<IDropdownOption<EFormDataType>[]>>();
  public readonly isFormSubmitted = input.required<boolean>();

  public readonly dropdownOptions: IDropdownOption<EFormDataType>[] = [
    {
      id: EFormDataType.numberOfFormSubmissions,
      name: this.translate.instant('page.widgetContent.addEditDialog.formDataTypeDropdown.numberOfFormSubmissions'),
    },
    {
      id: EFormDataType.valueFromContent,
      name: this.translate.instant('page.widgetContent.addEditDialog.formDataTypeDropdown.valueFromContent'),
    },
  ];

  public readonly dropdownSettings: IDropdownSettings = {
    enableSearchFilter: false,
    hasDelayedDefaultValue: true,
    isClientSide: true,
    repositionDropdownList: true,
    singleSelection: true,
    text: this.translate.instant('page.widgetContent.addEditDialog.formDataTypeDropdown.label'),
  };
}
